import WorkIm from '../assets/projects/oseas.png'

export const data=[
    {
        id:1,
        name:"OSEAS CRM Financial Platform",
        image:WorkIm,
        github:"",
        live:"",
    },
]